import { EskatLogo } from '@monthio/icons'
import styled from 'styled-components'

const LogoImage = styled(EskatLogo)`
	max-width: 270px;
`

export const EskatLogoImage = (): JSX.Element => <LogoImage />
